import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

const StatCard = (props) => {
  const {title, value, icon, bgColor, children, titleColor = 'text.primary', valueColor = 'text.primary'} = props;
  return (
    <Box sx={{
      p: 2,
      borderRadius: 2,
      backgroundColor: bgColor,
      border: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    }}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 0.5}}>
        <Box sx={{
          width: 32,
          height: 32,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid rgba(0, 0, 0, 0.1)',
        }}>
          {React.cloneElement(icon, {sx: {color: titleColor, fontSize: '1.25rem'}})}
        </Box>
        <Typography variant="body2" sx={{fontWeight: 'soft', color: titleColor}}>
          {title}
        </Typography>
      </Box>
      <Typography variant="h5" sx={{fontWeight: 'bold', color: valueColor, mt: 0.5}}>
        {children || value}
      </Typography>
    </Box>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  bgColor: PropTypes.string.isRequired,
  value: PropTypes.node,
  children: PropTypes.node,
  titleColor: PropTypes.string,
  valueColor: PropTypes.string,
};

export default StatCard;
